import { render, staticRenderFns } from "./QueryReportCard.vue?vue&type=template&id=3dddc014&scoped=true&"
import script from "./QueryReportCard.vue?vue&type=script&lang=js&"
export * from "./QueryReportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dddc014",
  null
  
)

export default component.exports